import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LuChartPie, LuGift, LuPartyPopper, LuScanQrCode } from "react-icons/lu";
import { cn } from "../../../util/general";

const navItems = [
  { icon: <LuChartPie size={20} />, label: "Inicio", path: "/resumen" },
  { icon: <LuGift size={20} />, label: "Sorteos", path: "/sorteos" },
  { icon: <LuScanQrCode size={20} />, label: "QR", path: "/lector-qr" },
  { icon: <LuPartyPopper size={20} />, label: "Promos", path: "/promociones" },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeIndex = navItems.findIndex((item) => item.path === pathname);

  return (
    <div className="fixed bottom-0 left-0 z-10 w-full px-4 pb-4">
      <div className="flex flex-row items-center justify-between gap-1 overflow-visible bg-white border rounded-[32px] px-3 text-slate-950 border-slate-100">
        {navItems.map((item, idx) => {
          const isActive = idx === activeIndex;

          return (
            <button
              key={idx}
              className={cn(
                "flex h-16 w-16 shrink-0 flex-col items-center gap-1 justify-center rounded-[32px] cursor-pointer transition duration-200 ease-in-out",
                isActive ? "text-blue-700" : "bg-transparent text-slate-950 hover:bg-primary/10"
              )}
              style={{ transitionProperty: "background, color, transform" }}
              onClick={() => navigate(item.path)}
              type="button"
              aria-label={item.label || "QR"}
            >
              {item.icon}
              {item.label ? (
                <span className={cn("text-[12px]", isActive ? "font-semibold" : "font-normal")}>
                  {item.label}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
